import { AdjacentTank } from './AdjacentTank';
import { Coating } from './Coating';
import { FuelTankType } from './FuelTankType';

export class Tank {
    constructor(
        tankId: number,
        tankName: string,
        odfjellTankName: string,
        volumeAt98Percent: number | null,
        heatingMedium: string,
        cargoPumpCapacity: number | null,
        maxHeating: number | null,
        heatingCapacity: number | null,
        maxVapourPressure: number | null,
        volume: number | null,
        imoTankType: number | null,
        ibcTankType: number | null,
        hasPoCapacity: boolean | null,
        maxWeightAt98Percent: number | null,
        tankType: number | null,
        startFrame: number | null,
        endFrame: number | null,
        xStart: number | null,
        yStart: number | null,
        height: number | null,
        width: number | null,
        section: number | null,
        side: number | null,
        hasCofferdamForward: boolean | null,
        hasCofferdamStarboard: boolean | null,
        hasCofferdamAft: boolean | null,
        hasCofferdamPort: boolean | null,
        allow2K: boolean | null,
        coatingType: number,
        coatingId: number | null,
        hasCooling: boolean | null,
        hasLitreWeightLimitation: boolean | null,
        heatingType: number | null,
        ibcCompatibilities: string[],
        adjacentTanks: AdjacentTank[],
        litreWeightHardRule: number | null,
        litreWeightSoftRule: number | null,
        fuelTankType: FuelTankType | null,
        widthInManifoldPlan: number | null,
        orderInManifoldPlan: number | null
    ) {
        this.tankId = tankId;
        this.tankName = tankName;
        this.odfjellTankName = odfjellTankName;
        this.volumeAt98Percent = volumeAt98Percent;
        this.heatingMedium = heatingMedium;
        this.cargoPumpCapacity = cargoPumpCapacity;
        this.maxHeating = maxHeating;
        this.heatingCapacity = heatingCapacity;
        this.maxVapourPressure = maxVapourPressure;
        this.volume = volume;
        this.imoTankType = imoTankType;
        this.ibcTankType = ibcTankType;
        this.hasPoCapacity = hasPoCapacity;
        this.maxWeightAt98Percent = maxWeightAt98Percent;
        this.tankType = tankType;
        this.startFrame = startFrame;
        this.endFrame = endFrame;
        this.xStart = xStart;
        this.yStart = yStart;
        this.height = height;
        this.width = width;
        this.section = section;
        this.side = side;
        this.hasCofferdamForward = hasCofferdamForward;
        this.hasCofferdamStarboard = hasCofferdamStarboard;
        this.hasCofferdamAft = hasCofferdamAft;
        this.hasCofferdamPort = hasCofferdamPort;
        this.allow2K = allow2K;
        this.coatingType = coatingType;
        this.coatingId = coatingId;
        this.coating = null;
        this.hasCooling = hasCooling;
        this.hasLitreWeightLimitation = hasLitreWeightLimitation;
        this.heatingType = heatingType;
        this.ibcCompatibilities = ibcCompatibilities;
        this.adjacentTanks = adjacentTanks;
        this.litreWeightHardRule = litreWeightHardRule;
        this.litreWeightSoftRule = litreWeightSoftRule;
        this.fuelTankType = fuelTankType;
        this.widthInManifoldPlan = widthInManifoldPlan;
        this.orderInManifoldPlan = orderInManifoldPlan;
    }
    tankId: number;
    tankName: string;
    odfjellTankName: string;
    volumeAt98Percent: number | null;
    heatingMedium: string;
    cargoPumpCapacity: number | null;
    maxHeating: number | null;
    heatingCapacity: number | null;
    maxVapourPressure: number | null;
    volume: number | null;
    imoTankType: number | null;
    ibcTankType: number | null;
    hasPoCapacity: boolean | null;
    maxWeightAt98Percent: number | null;
    tankType: number | null;
    startFrame: number | null;
    endFrame: number | null;
    xStart: number | null;
    yStart: number | null;
    height: number | null;
    width: number | null;
    section: number | null;
    side: number | null;
    hasCofferdamForward: boolean | null;
    hasCofferdamStarboard: boolean | null;
    hasCofferdamAft: boolean | null;
    hasCofferdamPort: boolean | null;
    allow2K: boolean | null;
    coatingType: number;
    coatingId: number | null;
    coating: Coating;
    hasCooling: boolean | null;
    hasLitreWeightLimitation: boolean | null;
    heatingType: number | null;
    ibcCompatibilities: string[];
    adjacentTanks: AdjacentTank[];
    litreWeightHardRule: number | null;
    litreWeightSoftRule: number | null;
    fuelTankType: FuelTankType | null;
    widthInManifoldPlan: number | null;
    orderInManifoldPlan: number | null;
}
